import { IQueryResponse } from './IQueryResponse';

export interface IPageData<T> {
  totalElements: number;
  pageNumber: number;
  pageSize: number;
  content: T[];
}

export const convertFromIQueryResponseToIPageData = <X, Y>(
  response: IQueryResponse<X>,
  convert: (data: X) => Y
): IPageData<Y> => ({
  pageNumber: response.pageable.pageNumber,
  pageSize: response.pageable.pageSize,
  totalElements: response.totalElements,
  content: response.content.map(convert),
});

export const createDefaultPageData = <Data>(): IPageData<Data> => ({
  totalElements: 0,
  pageNumber: 0,
  pageSize: 0,
  content: [],
});
